/**
 * URL publique des photos stockées par Laravel (php artisan storage:link).
 * photo_path en base = "visit_reports/<uuid>_<index>.jpg"
 * => image = PHOTO_BASE_URL + photo_path
 */
export const PHOTO_BASE_URL = 'https://VOTRE-SERVEUR-LARAVEL/storage/'

/** Libellés courts des objets de visite (codes ENUM MySQL). */
export const OBJET_LABELS = {
    COMMANDE: 'Prise de commande',
    CADENCIER: 'Cadencier',
    MERCHANDISING: 'Contrôle merchandising',
    DISPONIBILITE: 'Disponibilité gamme',
    PROMO: 'Opération promo',
    SUIVI_ACTION: "Suivi d'action",
    NEGOCIATION: 'Négociation espace',
    AUTRE: 'Autre',
}

/** Titres des sous-sections de l'évaluation merchandising. */
export const SECTION_TITLES = {
    '5.1': 'Disponibilité de la gamme',
    '5.2': 'Implantation et visibilité du rayon',
    '5.3': 'Qualité de présentation du rayon',
    '5.4': 'Gestion des produits frais',
}

/** Échelle de notation identique à l'application Android. */
export const SCALE = [
    { note: 4, label: 'Très satisfaisant', color: '#1E9E6A' },
    { note: 3, label: 'Satisfaisant', color: '#4F8BF0' },
    { note: 2, label: 'Insuffisant', color: '#E8A33D' },
    { note: 1, label: 'Critique', color: '#D9483B' },
    { note: 0, label: 'RAS', color: '#A3ACBD' },
]

/** Couleur associée à une moyenne (arrondie à la note la plus proche). */
export const colorForNote = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '#A3ACBD'
    const rounded = Math.max(1, Math.min(4, Math.round(Number(value))))
    return SCALE.find((s) => s.note === rounded).color
}

export const labelForNote = (value) => {
    if (value === null || value === undefined || isNaN(value)) return 'Non évalué'
    const rounded = Math.max(1, Math.min(4, Math.round(Number(value))))
    return SCALE.find((s) => s.note === rounded).label
}
